import { Theme } from '@insights-gaming/theme';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';
import classNames from 'classnames';
import React from 'react';

import TagListItem from './TagListItem';

interface TagListItemSkeletonOwnProps {
  className?: string;
}

type TagListItemSkeletonProps = TagListItemSkeletonOwnProps;

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {},
}), {name: 'TagListItemSkeleton'});

function TagListItemSkeleton(props: TagListItemSkeletonProps) {
  const classes = useStyles(props);
  const { className } = props;
  return (
    <TagListItem
    className={classNames(classes.root, className)}
    name={(
      <Skeleton variant='text' />
    )}
    />
  );
}

export default React.memo(TagListItemSkeleton);
